// extracted by mini-css-extract-plugin
export default {"listScreenRoot":"listScreen_listScreenRoot__KQJot"};